<template>
    <div class="big-wrap">
        <div class="app-wrap">
            <h1 class="url">beijobet.com</h1>
            <div class="Tips">
                Quanto mais você joga, mais recompensas você ganha, que você pode receber todos os dias
            </div>

            <div class="total">
                <div class="total-money">Recompensa total <b style="float:right"> R${{ reward_data.total }} </b></div>
                <div class="receive-money">Recompensas recebidas <b style="float:right">R${{ reward_data.receive_money }}
                    </b></div>
                <div class="unreceive-money">Recompensa não reivindicada <b style="float:right">R${{ reward_data.money }}
                    </b></div>
            </div>

            <div class="items">
                <div class="title" style="text-align:center;">{{ timestampToMMDDYYYY(reward_data.createtime) }}</div>
                <div class="title">Tipo de Evento: <b style="float:right">Recompensa</b></div>
                <div style="margin: 5px 0;">
                    <p style="height:0.5rem">Aposta válida <b class="bet-money">R${{ reward_data.bet_money }}</b></p>
                    <p style="margin-top:10px;height:0.5rem">Recompensa não reivindicada <b class="fanshui">R${{ reward_data.money }}</b>
                    </p>
                </div>
                <div class="revice" v-if="reward_data.status == 0" @click="receive()">Receber</div>
                <div class="revice2" v-if="reward_data.status == 1">Recebido</div>
            </div>

        </div>
        <ft></ft>
    </div>
</template>
<script>
import Vue from "vue";
import { Notify } from 'vant';
import Fetch from "../../utils/fetch";
import ft from "../../components/ft.vue"
Vue.use(Notify);
export default {
    name: 'app',
    data() {
        return {
            reward_list: [],
            max_show: 5,
            reward_data: {},
        };
    },
    mounted() {
        this.$parent.footer("reward");

        this.getData();
    },
    components: {
        ft
    },
    methods: {
        getData() {
            this.reward_data = {};
            Fetch('/reward/bet_reward_list', {}).then(res => {
                if (res.data)  this.reward_data = res.data;
            })
        },
        timestampToMMDDYYYY(timestamp) {
            const date = new Date(timestamp * 1000); // 将秒级时间戳转换为毫秒级
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要加1，并且保证两位数格式
            const day = date.getDate().toString().padStart(2, '0'); // 天数保证两位数格式
            const year = date.getFullYear();

            return `${month}/${day}/${year}`;
        },
        receive() {
            Fetch('/reward/receive_bet_reward', {}).then(res => {
                console.log(res);
                if (res.code == 1) {
                    Notify({ type: 'success', message: "Recebido com sucesso" });
                    setTimeout(() => {
                        this.getData()
                    }, 500);
                }
            })
        }
    }

}


</script>
<style scoped>
.total>div {
    font-size: 0.32rem;
    line-height: 0.6rem;
}

.total {
    width: 100%;
    border: 1px solid #84A559;
    border-radius: 5px;
    margin-bottom: 0.3rem;
    color: #84A559;
    padding: 0.3rem 0.34rem;
}
.show_more {
    color: #84A559;
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    bottom: 0;
    text-align: center;
    font-size: 0.35rem;
}

.url {
    text-align: center;
    font-size: 22px;
    color: gold;
    margin-bottom: 20px;
}

.bet-money {
    font-size: 0.4rem;
    color: green;
}

.fanshui {
    font-size: 0.4rem;
    color: red;
}

.revice {
    height: 30px;
    line-height: 30px;
    color: #fff;
    font-weight: 700;
    font-size: 0.35rem;
    width: 80%;
    margin: 0 auto;
    background-color: rgba(233, 214, 0, 0.947);
    text-align: center;
    border-radius: 5px;
    margin-top: 10px;
}

.revice2 {
    height: 30px;
    line-height: 30px;
    color: #fff;
    font-weight: 700;
    font-size: 0.35rem;
    width: 80%;
    margin: 0 auto;
    background-color: rgba(131, 130, 127, 0.947);
    text-align: center;
    border-radius: 5px;
    margin-top: 10px;
}

.title {
    height: 30px;
    line-height: 30px;
    color: white;
}

.Tips {
    width: 100%;
    height: auto;
    /* background: rgba(37, 82, 21, 0.343); */
    border-radius: 10px;
    padding: 0.34rem;
    padding-bottom: 15px;
    font-size: 0.35rem;
    color: #e5e5e5;
    line-height: 25px;
    margin-bottom: 15px;

}

.items {
    width: 100%;
    height: auto;
    background: rgba(37, 82, 21, 0.343);
    border-radius: 10px;
    padding: 0 0.34rem;
    padding-bottom: 15px;
    font-size: 0.35rem;
    color: #e5e5e5;
    margin-bottom: 10px;

}

.big-wrap {
    min-height: 100vh;
    background: url("../images/vip/vip.png");
}

.app-wrap {
    width: 95%;
    margin: 20px auto;
    padding: 10px;
    /* background: radial-gradient(#03cb50, transparent 86%); */
    margin-top: 20px;
    padding-bottom: 30px;
}</style>